import { Component, Input, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { FileBase } from './file-base';
import { IFile } from '../../_entities';

@Component({
	selector: 'media-view-modal',
	template: require('./media-view-modal.component.html')
})
export class MediaViewModalComponent extends FileBase{

	constructor(public sanitizer: DomSanitizer) { super(); }

	@ViewChild('modal') childModal: ModalDirective;

	title: string;
	media: IFile;

	pdfMediaUrl: SafeResourceUrl;

	get downloadPdfMediaUrl() {
		return `${this.media.url}/pdf?action=download`;
	}

	get downloadMediaUrl() {
		return `${this.media.url}?action=download`;
	}


	show(title: string, media: IFile): void {

		console.log("show");

		this.media = media;

		const pdfUrl = `${media.url}/pdf`;
		this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
		this.pdfMediaUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);

		this.title = title;
		this.childModal.show();
	}

	onHide(): void {
		this.childModal.hide();
	}




}






// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/file/media-view-modal.component.ts